import PromiseWorker from "promise-worker";
import mapboxLayerManagement from "worker-loader!./mapboxLayerManagement.worker.js";

const promiseMapboxLayerManagement = new PromiseWorker(
  new mapboxLayerManagement()
);

export { promiseMapboxLayerManagement };
